import {getInstance} from '@/auth/index.js';
const APIPREFIX = process.env.VUE_APP_APIPREFIX;

async function constructRequest(url, method) {
  const authService = getInstance();
  var token = await authService.getTokenSilently({
    aud: 'https://www.plait.ai/api',
  });
  var request = {};
  request.url = (await APIPREFIX) + url;
  request.method = method;
  request.headers = {Authorization: 'Bearer ' + token};
  return request;
}

function verifyAuthenticated() {
  var token = localStorage.getItem('plait-token');
  return $samsa.verifyAuthenticated.post(token);
}

export {APIPREFIX, constructRequest, verifyAuthenticated};
